import styled from 'styled-components'
import { Pagination as AntPagination } from 'antd'

import { MAX_MOBILE_WIDTH } from 'src/Styled/variables'

export const PaginationWrapper = styled.div`
  display: flex;
  gap: 24px;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => theme.color.white};
  width: 100%;
`

export const ItemsCounter = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
  font-size: 14px;
  line-height: 1.5;
  color: ${({ theme }) => theme.color.darkGrey};
  flex: 1 0 0;
  @media screen and (max-width: ${MAX_MOBILE_WIDTH}) {
    display: none;
  }
`

export const StyledPagination = styled(AntPagination)`
  .ant-pagination-prev,
  .ant-pagination-next {
    min-width: 40px;
    height: 40px;
    border-radius: 4px;

    .ant-pagination-item-link {
      border: none;
      background: transparent;
      display: flex;
      align-items: center;
      justify-content: center;
      color: ${({ theme }) => theme.color.darkGrey};
    }

    &:hover .ant-pagination-item-link {
      color: ${({ theme }) => theme.color.darkGreen};
      background: transparent;
    }
  }

  .ant-pagination-item {
    min-width: 40px;
    height: 40px;
    border-radius: 8px;
    border: 1px solid ${({ theme }) => theme.color.lightGrey};
    background: ${({ theme }) => theme.color.white};
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 2px;

    a {
      font-size: 14px;
      line-height: 1.5;
      color: ${({ theme }) => theme.color.darkGrey};
      padding: 8px;
    }

    &:hover {
      border-color: ${({ theme }) => theme.color.darkGreen};

      a {
        color: ${({ theme }) => theme.color.darkGreen};
      }
    }
  }

  .ant-pagination-item-active {
    background: ${({ theme }) => theme.color.lightGreen};
    border-color: ${({ theme }) => theme.color.lightGreen};

    a {
      color: ${({ theme }) => theme.color.darkGreen};
      font-weight: 400;
    }

    &:hover {
      background: ${({ theme }) => theme.color.lightGreen};
      border-color: ${({ theme }) => theme.color.lightGreen};

      a {
        color: ${({ theme }) => theme.color.darkGreen};
      }
    }
  }

  .ant-pagination-jump-prev,
  .ant-pagination-jump-next {
    min-width: 40px;
    height: 40px;
    border-radius: 8px;
    background: ${({ theme }) => theme.color.white};
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 2px;

    .ant-pagination-item-container {
      .ant-pagination-item-ellipsis {
        color: ${({ theme }) => theme.color.darkGrey};
      }

      .ant-pagination-item-link-icon {
        color: ${({ theme }) => theme.color.darkGrey};
      }
    }

    &:hover {
      .ant-pagination-item-container {
        .ant-pagination-item-link-icon {
          color: ${({ theme }) => theme.color.darkGreen};
        }
      }
    }
  }

  .ant-pagination-disabled {
    .ant-pagination-item-link {
      color: ${({ theme }) => theme.color.lightGrey};
    }

    &:hover .ant-pagination-item-link {
      color: ${({ theme }) => theme.color.lightGrey};
    }
  }
`
